module.exports = __webpack_public_path__ + "media/images/favicons/favicon-16x16-d635f13ef61350fa5627c7331839fda8.png";